import Popup from "@codesmith-99/reactjs-popup";
export default Popup;